import React from 'react';
import {
  BtnBold,
  BtnItalic,
  Editor,
  EditorProvider,
  Toolbar,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  Separator,
} from 'react-simple-wysiwyg';

const BtnHighlightYellow = () => {
  const applyHighlight = () => {
    document.execCommand('backColor', false, '#fffe0d');
  };

  return (
    <button
      type='button'
      className='btn btn-sm p-0 d-flex align-items-center justify-content-center'
      style={{
        width: '28px',
        height: '28px',
        border: '1px solid #ced4da',
        borderRadius: '4px',
        backgroundColor: '#fffe0d',
      }}
      title='Highlight Yellow'
      onClick={applyHighlight}
    >
      <i className='ri-mark-pen-line text-dark fs-14'></i>
    </button>
  );
};

const BtnRemoveHighlight = () => {
  const removeHighlight = () => {
    document.execCommand('backColor', false, 'transparent');
  };

  return (
    <button
      type='button'
      className='btn btn-sm p-0 d-flex align-items-center justify-content-center border bg-white'
      style={{ width: '28px', height: '28px', borderRadius: '4px' }}
      title='Remove Highlight'
      onClick={removeHighlight}
    >
      <i className='ri-eraser-line text-danger fs-14'></i>
    </button>
  );
};

const RespondNotesEditor = ({ id, value, onChange, isDraftDirty = false }) => (
  <div
    className={`editor-wrapper ${isDraftDirty ? 'border border-warning rounded' : ''}`}
  >
    <EditorProvider>
      <Editor
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        style={{ height: '200px', overflowY: 'auto' }}
        className='form-control bg-white'
      >
        <Toolbar>
          <BtnStyles />
          <BtnBold />
          <BtnItalic />
          <Separator />
          <BtnStrikeThrough />
          <BtnUnderline />
          <Separator />
          <BtnBulletList />
          <BtnNumberedList />
          <Separator />
          <BtnHighlightYellow />
          <BtnRemoveHighlight />
          <Separator />
          <BtnLink />
          <Separator />
          <BtnUndo />
          <BtnRedo />
          <Separator />
          <BtnClearFormatting />
        </Toolbar>
      </Editor>
    </EditorProvider>
  </div>
);

export default RespondNotesEditor;
